import {useUserProfileSlug} from '@app/profile/requests/use-user-profile-slug';

export function UserProfileSlug() {
  const userData = useUserProfileSlug();
  if (!userData.data) {
    return <div>Loading user profile...</div>;
  }
  const user = userData.data.user;
  return (window.location.href = `/user/${user.id}/${user.username}`);
}
